/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import BackButton from '../../components/BackButton'
import BankList from '../Banks/BankList'
import SearchReferenceInput from '../../components/QuickSearch/QuickSearch'
import '../style.css'
import Title from '../../components/Title/Title'
import CustomValidater from '../../components/Utility/Validater'

const BranchComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const { isEdit, title, record } = props
    const userData = {
        gl_id: 1,
        created_by: user.description,
        modified_by: user.description,
    }

    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>
            <div className="container">
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                    }}
                >
                    <SearchReferenceInput
                        {...props}
                        source="bank_id"
                        reference="Bank"
                        allowEmpty
                        validate={required()}
                        perPage={10000}
                        list={BankList}
                        resource="PY_BankMasterTAB"
                        basePath="/PY_BankMasterTAB"
                    />
                </div>
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
        </SimpleForm>
    )
}
export default function CreateBranch(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_BankBranchTAB')
        refresh()
    }
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_BankBranchTAB" />
                <Edit {...props} undoable={false}>
                    <BranchComponent title="Edit Branch" isEdit />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_BankBranchTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <BranchComponent title="Create Branch" isEdit={false} />
            </Create>
        </>
    )
}

CreateBranch.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

BranchComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
